const taskTools = () => {
  const toolsParentElement = document.querySelector(`.js-tools-parent`);

  if (toolsParentElement) {
    const toolsBtnElement = toolsParentElement.querySelector(`.js-tools-btn`);
    const toolsModalElement = toolsParentElement.querySelector(`.js-tools-modal`);

    function onToolsBtnElementClick() {
      toggleModalElement();
    }

    function onDocumentClick(evt) {
      if (!evt.target.closest(`.js-tools-parent`)) {
        toggleModalElement();
      }
    }

    function toggleModalElement() {
      toolsModalElement.classList.toggle(`modal--show`);

      if (toolsModalElement.classList.contains(`modal--show`)) {
        document.addEventListener(`click`, onDocumentClick);
      } else {
        document.removeEventListener(`click`, onDocumentClick);
      }
    }

    toolsBtnElement.addEventListener(`click`, onToolsBtnElementClick);
  }
};

export {taskTools};
